import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import Toggle from 'react-toggle'
import { GarageModalItem } from './GarageModalItem'
import { errorToast, successToast } from '../../lib/toastAlert'
import { Spinner } from '../Spinner'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    marginTop: '30px',
    transform: 'translate(-50%, -50%)',
    padding: '15px',
  },
  overlay: {
    zIndex: 1500,
    margin: '10px',
  },
}

export default function AddToGarageModal({
  modalIsOpen,
  closeGarageModal,
  carId,
}) {
  const [newListTitle, setNewListTitle] = useState('')
  const [lists, setLists] = useState([])
  const [followPrice, setFollowPrice] = useState(true)
  const [loading, setLoading] = useState(true)

  Modal.setAppElement(`#${document.body.id}`)

  useEffect(() => {
    let mounted = true

    if (App.State.userSignedIn) {
      App.Request.get('/account/listings.json', {
        params: { car_id: carId },
      })
        .then((response) => {
          const { data } = response

          if (mounted) setLists(data)
        })
        .finally(() => {
          if (mounted) {
            setLoading(false)
          }
        })
    }

    return () => {
      mounted = false
    }
  }, [])

  const addNewList = (newList) => {
    successToast({
      title: I18n.t('garage.car_added', { garage: newList.title }),
    })

    setLists([newList, ...lists])
  }

  const handleNewListSubmit = () => {
    if (newListTitle) {
      App.Request.post('/account/listings.json', {
        title: newListTitle,
        car_id: carId,
        follow_price: followPrice,
      })
        .then((response) => {
          const { data, status } = response

          if (status === 200) {
            addNewList(data)
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            errorToast({
              title: `${err.response.data.join('<br />')}`,
            })
          } else {
            errorToast()
          }
        })
    }
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeGarageModal}
        style={customStyles}
        contentLabel="Garage Modal"
      >
        <div id="garage-modal">
          <button
            className="btn btn-sm float-end"
            onClick={closeGarageModal}
            type="button"
          >
            <i className="fas fa-times fa-lg text-danger" />
          </button>
          <div className="container garage-form p-5">
            <h3>{I18n.t('garage.add_to_garage')}</h3>
            <div className="row flex-column mt-5">
              <div className="mb-3">
                <label htmlFor="create-list" className="fw-bold">
                  {I18n.t('create_new_list')}
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="create-list"
                    value={newListTitle}
                    onChange={(e) => setNewListTitle(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleNewListSubmit}
                  >
                    {I18n.t('create_list')}
                  </button>
                </div>
              </div>
              <div className="col-md-9 mb-3">
                <div className="d-flex align-items-center">
                  <Toggle
                    id="follow-price-toggle"
                    checked={followPrice}
                    onChange={(e) => setFollowPrice(e.target.checked)}
                  />
                  <label
                    htmlFor="follow-price-toggle"
                    className="form-check-label fw-bold ms-1"
                  >
                    {I18n.t('garage.follow_car_prices')}
                  </label>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: I18n.t('garage.follow_price_explanation_html'),
                  }}
                />
              </div>
            </div>
            <div className="row">
              <ul className="list-unstyled list-group garage-modal-list-wrapper rounded-0">
                {loading && <Spinner />}
                {!loading &&
                  lists.map((list) => (
                    <GarageModalItem
                      list={list}
                      key={`list-item-${list.id}`}
                      carId={carId}
                    />
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
